import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Card, CardContent, Stack, Button, CircularProgress
} from "@mui/material";
import OperateurPicker from "../../layout/forms/OperateurPicker.js";

function DashboardEquipageModal({open, onClose, tournee, onSave, loading, onChauffeurChange, onEquipierChange}) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
        >
            <DialogTitle><strong>{tournee?.libelle}</strong></DialogTitle>

            <DialogContent>
                <Stack direction="row" spacing={2} justifyContent="space-evenly">
                    <Card>
                        <CardContent>
                            <OperateurPicker
                                label="Chauffeur"
                                selected={tournee?.chauffeur}
                                onChange={(val) => onChauffeurChange(tournee?.id, val)}
                                required
                            />
                        </CardContent>
                    </Card>

                    <Card>
                        <CardContent>
                            <OperateurPicker
                                label="Equipier"
                                selected={tournee?.equipier}
                                onChange={(val) => onEquipierChange(tournee?.id, val)}
                                allowNone
                            />
                        </CardContent>
                    </Card>
                </Stack>
            </DialogContent>

            <DialogActions>
                <Button onClick={onSave} variant="contained" color="secondary">
                    {!loading ? "Sauvegarder les modifications" : <CircularProgress size={20} />}
                </Button>
                <Button onClick={onClose} variant="contained" color="primary">
                    Annuler
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default DashboardEquipageModal;
